import React, { useEffect, useState } from 'react';
import { SettingsInput } from '../form/settings.Widget';
import {
  getIconMetadata,
  renderIconByLabel,
  renderIconBySlug,
  searchIcons,
} from '../../content/icons';

export const IconPicker = ({
  size = 24,
  value,
  onChange,
  placeholder = 'recherche icône',
  label = 'Icône',
  previewSize = 24,
  showPreview = true,
  className = '',
  inputClassName = '',
  gridClassName = '',
  maxHeight = 150,
  onClear = null,
}) => {
  const [query, setQuery] = useState('');
  const [icons, setIcons] = useState(getIconMetadata());
  const selectedIcon = icons.find(icon => icon?.slug === value || icon?.label === value);

  useEffect(() => {
    if (!query?.trim()) {
      setIcons(getIconMetadata());
      return;
    }
    setIcons(searchIcons(query));
  }, [query]);

  const handleSelect = icon => {
    if (!icon?.label) {
      return;
    }
    if (icon.label === value || icon.slug === value) {
      onChange?.(null, icon.slug);
    } else {
      onChange?.(icon.label, icon.slug);
    }
  };

  const handleClear = () => {
    onChange?.(null, null);
    if (typeof onClear === 'function') {
      onClear();
    }
  };

  return (
    <div className={`flex flex-col gap-05 text-contrast ${className}`}>
      <div className='flex gap-05 items-center w-full'>
        {label && <div>{label}</div>}
        {showPreview && (
          <div
            className='bg-main rounded py-05 px-1 flex items-center justify-center min-w-px40 min-h-px40 text-contrast'
            onDoubleClick={handleClear}
          >
            {renderIconBySlug(value, { size: previewSize }) ||
              renderIconByLabel(value, { size: previewSize })}
          </div>
        )}
        <SettingsInput
          placeholder={placeholder}
          initValue={query}
          onChange={e => setQuery(e.target.value)}
          onBlur={() => null}
          className={'flex-1 ' + inputClassName}
        />
      </div>

      <div
        className={`flex flex-wrap gap-05 overflow-y-auto ${gridClassName}`}
        style={{ maxHeight }}
      >
        {icons.map((icon, index) =>
          icon?.label ? (
            <div
              key={`${icon.slug}-${index}`}
              className={`cursor-pointer transition hover:opacity-50 text-contrast ${
                selectedIcon?.slug === icon.slug ? 'opacity-50' : ''
              }`}
              onClick={() => handleSelect(icon)}
            >
              {renderIconBySlug(icon.slug, { size })}
            </div>
          ) : (
            <div
              key={`spacer-${index}`}
              className='w-full'
            ></div>
          ),
        )}
      </div>
    </div>
  );
};
